import { useState } from 'react';
import { TabList } from '@skyline-platform/alchemy';
import { BulkDelete } from './BulkDelete';
import { AssignHostAppliance } from './HostAppliance';
import { ToggledSection } from './ToggledSection';
import { OnlineOffline } from './OnlineOffline';
import './BulkActions.css';
import { ItemsProvider } from './utils/ItemsContext';
import PropTypes from 'prop-types';
import { bulkUpdate, getConfirmBtnState } from './utils/bulkUpdate';

const rtspInterleavedDescription = (<>
  <span>
    Set the RTSP interleaved to On to enable interleaved RTSP transport to pull the streams
    using TCP protocol.
  </span>
  <br />
  <br />
  <span>
    Set the RTSP interleaved to Off to disable interleaved RTSP transport to pull the streams
    using UDP protocol.
  </span>
</>);

const onDemandDescription = (<>
  <span>
    Set the on demand to On to stop constantly pulling the streams from the source.
  </span>
  <br />
  <br />
  <span>
    Set the on demand to Off to constantly pull the streams from the source.
  </span>
</>);

const deleteDescription = (<>
  <span>Delete streams that are no longer needed.</span><br /><br />
  <span>Once updated, all selected video will be permanently removed from the system.</span>
</>);

const confirmDeleteDescription = (<>
  <span>Are you sure you want to delete the selected streams?</span>
</>);

export const StreamBulkActions = ({ streams, userIsAdmin }) => {
  const [confirmDelete, setConfirmDelete] = useState(false);

  return (
    <ItemsProvider streams={streams}>
      <stream-bulk-actions>
        <TabList
          type='menu'
          tabs={[
            'Online',
            'Offline',
            ...(userIsAdmin ? [
              'Host Appliance',
              'On Demand',
              'RTSP Interleaved',
              'Delete Streams',
            ] : []),
          ]}
          tabsprops={{ orientation: 'vertical' }}
          pages={[
            <OnlineOffline title='Online Streams' key='online' online={true} />,
            <OnlineOffline title='Offline Streams' key='offline' online={false} />,
            <AssignHostAppliance title='Assign Host Appliance' key='host-appliance' />,
            <ToggledSection
              title='On Demand'
              key='on-demand'
              description={onDemandDescription}
              onConfirmAction={(toggleState, streams) => {
                const update = {
                  pullOnRequest: toggleState,
                };
                bulkUpdate('update_stream', streams, update);
              }}
            />,
            <ToggledSection
              title='RTSP Interleaved'
              key='rtsp'
              description={rtspInterleavedDescription}
              onConfirmAction={(toggleState, streams) => {
                const update = {
                  useInterleavedRTSPTransport: toggleState,
                };
                bulkUpdate('update_stream', streams, update);
              }}
            />,
            <BulkDelete
              title='Delete Streams'
              key='delete'
              description={confirmDelete ? confirmDeleteDescription : deleteDescription}
              confirmBtnLabel={confirmDelete ? 'YES, DELETE STREAMS' : 'Delete Streams'}
              confirmBtnState={getConfirmBtnState(streams, confirmDelete)}
              confirmAction={() => setConfirmDelete(() => {
                if (confirmDelete) {
                  bulkUpdate('delete_stream', streams, {});
                  return false;
                }
                return true;
              })}
            />,
          ]}
        />
      </stream-bulk-actions>
    </ItemsProvider>
  );
};

StreamBulkActions.propTypes = {
  streams: PropTypes.array.isRequired,
  userIsAdmin: PropTypes.bool.isRequired,
};